import services from 'api/services';
import { logError } from 'util/errors';

import { GET_ACHIEVEMENTS_REQUEST, GET_ACHIEVEMENTS_SUCCESS, GET_ACHIEVEMENTS_FAILURE } from './constants';

const { AchievementService } = services;

export const getAchievements = (accountId) => async (dispatch) => {
  try {
    dispatch({ type: GET_ACHIEVEMENTS_REQUEST });
    const achievements = await AchievementService.getAchievements(accountId);

    dispatch({ type: GET_ACHIEVEMENTS_SUCCESS, achievements: achievements });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_ACHIEVEMENTS_FAILURE, error: ex.message });
  }
};
